<template>
    <v-dialog
        v-model="show"
        max-width="700px"
        persistent
        transition="dialog-transition">
        <v-card class="rounded-lg">
            <v-toolbar flat color="primary" dark>
                <v-icon left>mdi-clipboard-text-outline</v-icon>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
                <v-progress-circular
                  v-show="progress"
                  indeterminate
                  color="white"
                  size="24"
                  class="ml-3"
                ></v-progress-circular>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="show = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container class="pa-6">
                <v-progress-linear v-if="!formLoaded" indeterminate color="primary"></v-progress-linear>
                <form v-if="formLoaded" ref="form" class="mt-4">
                    <v-row>
                        <v-col cols="6">
                            <if65-date-picker
                                v-model="form.task_date"
                                ref="task_date"
                                :required="true"
                                :disabled="isEdit"
                                label="Data intervento"
                                outlined
                                dense
                                prepend-inner-icon="mdi-calendar"/>
                        </v-col>
                        <v-col cols="6">
                            <if65-autocomplete
                                v-if="product || taskProductId"
                                ref="sub_activity"
                                v-model="form.sub_activity"
                                :api="$subActivityService.list"
                                :extra-params="{product: productId}"
                                :required="true"
                                label="Sotto attività"
                                outlined
                                dense
                                prepend-inner-icon="mdi-format-list-bulleted"
                                @progress="finishGet" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card outlined class="pa-4 mb-4 rounded-lg">
                                <div class="d-flex align-center mb-3">
                                    <v-icon color="primary" class="mr-2">mdi-clock-outline</v-icon>
                                    <span class="text-subtitle-2 font-weight-medium primary--text">Tempo di lavoro</span>
                                </div>

                                <div class="d-flex justify-space-between align-center mb-2">
                                    <span class="font-weight-medium">Minuti:</span>
                                    <v-chip color="primary" outlined small class="font-weight-medium">{{ form.minutes }} min</v-chip>
                                </div>

                                <div class="d-flex justify-space-between align-center mb-4">
                                    <span class="font-weight-medium">Ore:</span>
                                    <v-chip color="success" outlined small class="font-weight-medium">{{ (form.minutes / 60).toFixed(1) }} ore</v-chip>
                                </div>

                                <div class="d-flex justify-space-between mb-n2">
                                    <span class="text-caption">0h</span>
                                    <span class="text-caption">2h</span>
                                    <span class="text-caption">4h</span>
                                    <span class="text-caption">6h</span>
                                    <span class="text-caption">8h</span>
                                    <span class="text-caption">10h</span>
                                    <span class="text-caption">12h</span>
                                    <span class="text-caption">14h</span>
                                </div>
                                <v-slider
                                    v-model="form.minutes"
                                    min="0"
                                    step="30"
                                    max="840"
                                    thumb-label="always"
                                    :thumb-size="24"
                                    color="primary"
                                    track-color="rgba(0, 0, 0, 0.1)"
                                    thumb-color="primary"
                                    height="50"
                                    ticks="always"
                                    tick-size="4"
                                    :label="val => `${(val/60).toFixed(1)}h`"
                                ></v-slider>

                                <div class="text-caption text-center grey--text mt-2">
                                    <v-icon small class="mr-1">mdi-information-outline</v-icon>
                                    Trascina il cursore per selezionare il tempo di lavoro (incrementi di 30 minuti)
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card outlined class="pa-4 mb-4 rounded-lg">
                                <div class="d-flex align-center mb-3">
                                    <v-icon color="primary" class="mr-2">mdi-text-box-outline</v-icon>
                                    <span class="text-subtitle-2 font-weight-medium primary--text">Descrizione intervento</span>
                                </div>

                                <v-textarea
                                    outlined
                                    label="Descrivi il tuo intervento o l'anomalia riscontrata"
                                    v-model="form.description"
                                    rows="5"
                                    auto-grow
                                    counter
                                    class="mt-2"
                                ></v-textarea>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-card-actions class="pt-2">
                        <v-spacer></v-spacer>
                        <v-btn text @click="show = false" class="mr-2">Annulla</v-btn>
                        <v-btn color="primary" type="submit" @click.prevent="saveTask">
                            <v-icon left>mdi-content-save</v-icon>
                            Salva
                        </v-btn>
                    </v-card-actions>
                </form>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import If65Autocomplete from "../../components/widgets/If65Autocomplete.vue";
import If65DatePicker from "../../components/widgets/If65DatePicker.vue";

export default {
    components: {If65Autocomplete, If65DatePicker},
    props: {
        taskId: {
            default: null
        },
        product: {
            default: null
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            show: false,
            form: {
                description: '',
                task_date: null,
                sub_activity: null,
                minutes: 30
            },
            formLoaded: true,
            progress: true,
            taskProductId: null,
        }
    },
    computed: {
        isEdit() {
            return this.taskId !== null;
        },
        title() {
            return 'Descrivi il tuo intervento'
        },
        productId() {
          return this.product ? this.product.id : this.taskProductId
        }
    },
    mounted() {
            if (this.taskId) {
              this.formLoaded = false
              this.$taskService.get(this.taskId).then(
                response => {
                  this.form.description = response.data.description;
                  this.form.task_date = response.data.task_date;
                  this.form.sub_activity = response.data.sub_activity;
                  this.form.minutes = response.data.minutes;
                  this.taskProductId = response.data.product;
                }
              ).finally(() => {
                this.formLoaded = true
              })
            }
    },
    watch: {
        value: {
            handler() {
                this.show = this.value
            },
            immediate: true
        },
        show() {
            this.$emit('input', this.show)
        }
    },
    methods: {
        // allowedDates(date) {
        //     if ( this.$store.state.user.role !== "ADMIN") {
        //       return isToday(parseISO(date)) || isYesterday(parseISO(date));
        //     } return true
        // },
        formIsValid() {
            this.$refs['task_date'].$v.$touch()
            this.$refs['sub_activity'].$v.$touch()
            return (
                !this.$refs['task_date'].$v.$invalid &&
                !this.$refs['sub_activity'].$v.$invalid
            )
        },
        saveTask() {
            if (this.formIsValid()) {
                const saveApi = (
                    this.isEdit ? this.$taskService.patch(this.taskId, this.form) : this.$taskService.post(this.form)
                );
                saveApi.then(
                    () => {
                        this.$emit('taskSaved')
                        this.$dtoast.pop({
                            preset: "success",
                            content: 'Task salvato',
                        })
                    }
                ).catch(
                    (error) => {
                        let errorMessage = 'Errore nel salvataggio del task';

                        if (error.response?.data) {
                            // Prova a ottenere il messaggio di errore in vari formati
                            if (error.response.data.non_field_errors && Array.isArray(error.response.data.non_field_errors)) {
                                errorMessage = error.response.data.non_field_errors.join(', ');
                            } else if (error.response.data.detail) {
                                errorMessage = error.response.data.detail;
                            } else if (typeof error.response.data === 'string') {
                                errorMessage = error.response.data;
                            } else {
                                // Mostra il primo errore trovato
                                const firstError = Object.values(error.response.data)[0];
                                if (Array.isArray(firstError)) {
                                    errorMessage = firstError[0];
                                } else if (typeof firstError === 'string') {
                                    errorMessage = firstError;
                                }
                            }
                        }

                        this.$dtoast.pop({
                            preset: "error",
                            content: errorMessage
                        })
                    }
                )
            }
        },
        finishGet() {
          this.progress = false
        }
    }
}
</script>
